import * as React from 'react';

import { ISliderConf, NativeSlider } from '@notino/react-styleguide';

import { Arrow } from '@components/Arrow';
import { IImageProperties } from '@helpers/utils';

import { Image } from './Image';
import { SliderWrapper } from './styled';

interface IThumbsImagesProps {
  imageIndex: number;
  handleImageChange: (index: number) => void;
  handleImageClick?: (index: number) => React.MouseEventHandler<HTMLElement>;
  imagesAttrs: IImageProperties[];
  config: ISliderConf;
  cypressDataValue?: string;
}

export const Thumbs: React.FC<IThumbsImagesProps> = React.memo(
  ({
    imagesAttrs,
    config,
    handleImageChange,
    handleImageClick,
    imageIndex,
    cypressDataValue = '',
  }) => {
    const sliderConfig: ISliderConf = {
      prevArrow: <Arrow direction="left" color="icon.secondary" />,
      nextArrow: <Arrow direction="right" color="icon.secondary" />,
      ...config,
    };

    return (
      <SliderWrapper data-cypress={cypressDataValue}>
        <NativeSlider {...sliderConfig}>
          {imagesAttrs.map((imageAttr, index) => {
            const onMouseOver = () => handleImageChange(index);
            return (
              <Image
                {...imageAttr}
                key={imageAttr.src}
                isSelected={index === imageIndex}
                onClick={handleImageClick?.(index)}
                onMouseOver={onMouseOver}
              />
            );
          })}
        </NativeSlider>
      </SliderWrapper>
    );
  }
);
